<app-top-nav></app-top-nav>
<app-home></app-home>
<app-about></app-about>
<app-video></app-video>
<app-event-list></app-event-list>
<!--<app-photos></app-photos>
<app-music></app-music>-->
<app-booking></app-booking>
<!--<app-bottom-player></app-bottom-player>-->
